/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Component, Input } from '@angular/core';
import * as i0 from "@angular/core";
var SupplierOfficeInfoComponent = /** @class */ (function () {
    function SupplierOfficeInfoComponent() {
    }
    SupplierOfficeInfoComponent.ɵfac = function SupplierOfficeInfoComponent_Factory(t) { return new (t || SupplierOfficeInfoComponent)(); };
    SupplierOfficeInfoComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SupplierOfficeInfoComponent, selectors: [["gh-supplier-office-info"]], inputs: { office: "office" }, decls: 3, vars: 1, consts: [[1, "info-box"], [1, "info-box__details"]], template: function SupplierOfficeInfoComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.office.description);
        } }, styles: ["[_nghost-%COMP%] {\n  display: block; }"] });
    return SupplierOfficeInfoComponent;
}());
export { SupplierOfficeInfoComponent };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierOfficeInfoComponent, [{
        type: Component,
        args: [{
                selector: 'gh-supplier-office-info',
                templateUrl: 'supplier-office-info.component.html',
                styleUrls: ['supplier-office-info.component.scss'],
            }]
    }], null, { office: [{
            type: Input
        }] }); })();
